<template>
    <div class="col-sm-12" v-loading="loading">
        <div style="display: flex; justify-content: space-between">
            <h2>Proposals</h2>
            <div>
                <a class="btn btn-danger is-aligned-right" :href="url(`/admin/proposal/new`)">
                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span> New
                </a>
            </div>
        </div>

        <div>
            <form class="filter-group list-filter" style="display: flex; flex-wrap: wrap;">
                <div class="form-group"><label>From</label> <input type="date" class="form-control" v-model="filter.date_from"></div>
                <div class="form-group"><label>To</label> <input type="date" class="form-control" v-model="filter.date_to"></div>
                <div class="form-group">
                    <label style="display: block">Author</label>
                    <el-select v-model="filter.author" filterable @change="refresh">
                        <el-option :value="null">...</el-option>
                        <el-option :label="o.name" :key="o.id" :value="o.id" v-for="o in users"></el-option>
                    </el-select>
                </div>
                <div class="form-group"><label>Search</label> <input type="text" class="form-control" v-model="filter.search" v-on:keyup.enter="refresh"></div>
                <div class="form-group" style="padding-top: 25px">
                    <btn cssClass="btn btn-secondary" icon="fas fa-redo-alt" :click="refresh">Filter</btn>
                </div>
            </form>
        </div>

        <div>
            <table class="table table-striped table-hover table-sticky-header custom-table">
                <thead>
                    <tr>
                        <th>Author</th>
                        <th>Created</th>
                        <th>Company</th>
                        <th>MRR</th>
                        <th>Contact</th>
                        <th>Signed</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in rows">
                        <td>{{ row.created_by }}</td>
                        <td>{{ row.date }}</td>
                        <td v-if="row.employer_id"><a :href="url(`admin/employer/${row.employer_id}/budgets`)">{{ row.name }}</a></td>
                        <td v-else>{{ row.name }}</td>
                        <td>{{ money(row.signed_price || row.monthly_price) }}</td>
                        <td>{{ row.contact_name }}<br><a :href="`mailto:${row.contact_email}`">{{ row.contact_email }}</a></td>
                        <td>
                            <a v-if="row.signed_pdf_cloud_file_id" :href="url(`admin/proposal/${row.id}/pdf`)">{{ row.signed_by }} / {{ row.title }}</a>
                            <span v-else-if="row.signed_at">{{ row.signed_by }} / {{ row.title }}</span>
                            <a v-if="row.signed_at" href="#" @click.prevent="confirmUnsign(row)">(<i class="far fa-close"></i> remove signature)</a>
                            <span v-if="row.signed_at"><br />{{ row.signed_at }}</span>
                        </td>
                        <td><a :href="url(`admin/proposal/${row.id}/clone`)">Clone</a></td>
                        <td><a :href="url(`admin/proposal/${row.id}/detail`)">Update</a></td>
                        <td>
                            <div>
                                <a :href="url(`proposal/${row.key}`)">Terms - Link to Sign</a>
                                <a href="#" @click.prevent="saveToClipboard(url(`proposal/${row.key}`))">(<i class="far fa-copy"></i> copy)</a>
                            </div>
                            <div>
                                <a :href="url(`our-proposal/${row.key}`)">Proposal - Link to Sign</a>
                                <a href="#" @click.prevent="saveToClipboard(url(`our-proposal/${row.key}`))">(<i class="far fa-copy"></i> copy)</a>
                            </div>
                        </td>
                        <td><a :href="url(`admin/proposal/${row.id}/delete`)">Delete</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: [
    ],
    components: {
    },
    data() {
        return {
            filter: {
                author: window.user_id,
                date_from: null,
                date_to: null
            },
            users: [],
            rows: [],
            loading: true
        };
    },
    methods: {
        refresh() {
            this.loading = true;
            return axios.get(url(`admin/proposal/list/data`), { params: this.filter })
                .then((response) => {
                    this.rows = response.data.list;
                    this.loading = false;
                });
        },
        saveToClipboard(link) {
            const el = document.createElement('textarea');
            el.value = link;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.$message('Link saved to your clipboard');
        },
        confirmUnsign(row) {
            this.$confirm(
                'Are you sure to remove the proposal signature?',
                'Remove Signature', {
                    confirmButtonText: 'Yes, remove',
                    cancelButtonText: 'Cancel'
                })
                .then(() => {
                    window.location.href = url(`admin/proposal/${row.id}/unsign`);
                });
        },
    },
    mounted() {
        this.refresh();
        axios.get(url(`admin/user/dropdown`))
            .then((response) => {
                this.users = response.data;
            });
    }
}
</script>

<style>
</style>
